import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";

export const VIDEO_SRC = "/img/afr-flythrough.mp4";

export const useHeroVideo = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    const v = ref.current;
    if (!v) return undefined;
    const on = () => setPlaying(true);
    const off = () => setPlaying(false);
    v.addEventListener("play", on);
    v.addEventListener("pause", off);
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) v.pause();
    else setPlaying(!v.paused);
    return () => {
      v.removeEventListener("play", on);
      v.removeEventListener("pause", off);
    };
  }, []);
  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) v.play().catch(() => null);
    else v.pause();
  };
  return { ref, playing, toggle };
};

export const HeroVideo = ({ video, testId = "hero-video" }) => (
  <video ref={video.ref} data-testid={testId} className="h-full w-full object-cover" src={VIDEO_SRC} poster="/img/afr-site-2026-03.jpg" autoPlay muted loop playsInline preload="auto" aria-label="Animated rendering flying over the planned AFR refinery site at the Port of Brownsville" />
);

export const VideoToggle = ({ video, testId = "hero-video-toggle", className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    <button onClick={video.toggle} data-testid={testId} aria-label={video.playing ? "Pause video" : "Play video"} className="flex items-center gap-2 border border-white/30 bg-[#061235]/60 px-4 py-2.5 text-sm font-semibold backdrop-blur-md transition-colors hover:border-white">
      {video.playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}{video.playing ? "Pause" : "Play"}
    </button>
  </div>
);
